// @ts-strict-ignore
import React, { MouseEventHandler, ReactNode, useEffect, useRef } from 'react';
import { ColorProps } from 'styled-system';

import { setupLinkTracker } from 'utils/analytics';

import { Link } from './Link';

type Props = ColorProps & {
  'aria-label'?: string;
  className?: string;
  children?: ReactNode;
  'data-qa-id'?: string;
  eventName?: string;
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  eventProperties?: Record<string, any>;
  href: string;
  waitForHref?: boolean;
  tabIndex?: number;
  target?: string;
  title?: string;
  rel?: string;
  onClick?: MouseEventHandler;
};

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line consistent-return
const updateTracker = (eventName, eventProperties, linkRef) => {
  if (eventName && linkRef && linkRef.current) {
    return setupLinkTracker(eventName, eventProperties)(linkRef.current);
  }
};

export function TrackedLink({ waitForHref, ...props }: Props) {
  const linkRef = useRef(null);
  useEffect(() => {
    const clickHandler = updateTracker(
      props.eventName,
      props.eventProperties,
      linkRef
    );
    const el = linkRef.current;
    return () => {
      if (el && clickHandler) {
        el.removeEventListener('click', clickHandler);
      }
    };
  }, [props.eventName, props.eventProperties]);

  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/jsx-props-no-spreading
  return <Link key={props.eventName} {...props} ref={linkRef} />;
}
